import { render, staticRenderFns } from "./ContentWrap.vue?vue&type=template&id=67c5611a&"
import script from "./ContentWrap.vue?vue&type=script&lang=ts&"
export * from "./ContentWrap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports